import { useEffect, useState } from 'react';
/**
 * `false` on the server and for the first client render, `true` afterwards. Use it to defer
 * anything that needs the DOM (portals, `window`) until hydration has matched the server output.
 */
export const useHasMounted = () => {
    const [hasMounted, setHasMounted] = useState(false);
    useEffect(() => setHasMounted(true), []);
    return hasMounted;
};
